import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-up",
  "use": "arrow-up-usage",
  "viewBox": "0 0 10 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 13\" id=\"arrow-up\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.383 12.243a.873.873 0 0 0 1.49-.617V3.492l2 2.001a.874.874 0 0 0 1.236-1.235L5.693.842a.873.873 0 0 0-1.386 0L.892 4.259a.873.873 0 1 0 1.235 1.235l2-2v8.133c0 .231.093.453.256.617Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol